import Swiper_Mobile from 'classes/Swiper_Mobile';
import { load_swiper_init } from 'modules/carousel/load_swiper';

let initialized = false;

export function load_swiper_mobile(){
    document.addEventListener('swiper_ready', swiper_mobile_init);
    load_swiper_init(swiper_mobile_init);
}

function swiper_mobile_init(){

    if(initialized) return;
    initialized = true;
    
    function on_mobile(){

        if( window.innerWidth >= 768 ) return; // mobile devices screen only

        const e = new Event('swiper_mobile_ready');
        e.Swiper_Mobile = Swiper_Mobile;
        document.dispatchEvent(e);

        window.removeEventListener('resize', on_mobile);

        new Swiper_Mobile({
            container: '.section-box',
            items:'.elementor-widget-image',
            bullets:true,
            extend_swiper_settings:{
                spaceBetween:20,
                slidesPerView:2,
                slidesPerGroup:2,
            }
        });
    }

    on_mobile();

    window.addEventListener('resize', on_mobile);
}